<template>
  <div id="Product" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
        <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5">
          <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
          <div class="col-6 t-c color-primary"><span class="f24 fw">P</span>roducto</div>
          <div class="col-3 t-r f34 pr3" @click="statusCh()">
            <div class="col-12" v-if="$route.query.from =='M_ProductsList'">
              <i class="iconfont icon-kaiguan4 color-primary" v-if="pageData.status == 1"></i>
              <i class="iconfont icon-kaiguan3 color-muted" v-else></i>
            </div>
          </div>
        </div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 t-c bg-color-white">
        <div class="col-12 p5">
          <img v-bind:src="pageData.pic" v-if="pageData.pic" class="w24">
          <img src="@/assets/goods.jpg" v-else class="w24">
        </div>
      </div>
      <div class="col-12 color-muted lh22 f14">
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10 mt5 mb5" v-if="$route.query.from !='M_ProductsList'">
          <!--
          <div class="col-4">En existencia</div>
          <div class="col-7 t-r color-black">
            <div class="" :class="{'color-danger': pageData.qty <= 0,'color-primary': pageData.qty > 0 && pageData.qty - pageData.qty_min > 0,'color-warning': pageData.qty > 0 && pageData.qty - pageData.qty_min <= 0}"> 
              <span v-if="pageData.qty > 0" class="fw f26">{{ Math.floor(pageData.qty / pageData.price_package_qty ) }}</span>
              <span v-else class="fw f26">{{ fun.formatMoney(pageData.qty,2,'.',',',true) }}</span>
              <span class="color-muted" v-if="pageData.qty > 0"> Bulto </span>
              <span class="f26 fw" v-if="pageData.qty % pageData.price_package_qty  > 0"> + {{ pageData.qty % pageData.price_package_qty  }}<span class="color-muted f14"> u</span></span>
            </div>
          </div>
          <div class="col-1 t-r">
            <i class="iconfont icon-edit f20"></i>
          </div>
          -->
          <div class="col-12 f14 pb10">
            <div class="col-8">En existencia</div>
            <div class="col-4 t-r" v-if="!stock_edit">
              <i class="iconfont icon-edit f20" @click="stock_edit_on"></i>
            </div>
            <div class="col-4 t-r" v-else>
              <i class="iconfont icon-31guanbi f20" @click="stock_edit = false"></i>
            </div>
          </div>
          <div class="col-12" @click="warehouseLog()">
            <div class="col-5 t-c">
              <div class="col-12 mb5">
              <input type="number" class="b1 lh46 pl3 pr3 w12 r5 t-c f26 fw" v-model="new_package" v-if="stock_edit" v-select-on-focus> 
              <span class="fw f26 color-primary lh48" v-else>{{ Math.floor(pageData.qty / pageData.price_package_qty ) }}</span>
              </div>
              <div class="col-12 color-muted f12">Bulto <span v-if="pageData.price_package_qty > 1"> x {{ fun.formatMoney(pageData.price_package_qty,0,'.',',') }}</span></div>
            </div>
            <div class="col-2 t-c f30 lh46"> + </div>
            <div class="col-5 t-c"> 
              <div class="col-12 mb5">
              <input type="number" class="b1 lh46 pl3 pr3 w12 r5 t-c f26 fw" v-model="new_qty" v-if="stock_edit" v-select-on-focus>
              <span class="fw f26 color-primary lh48" v-else>{{ pageData.qty % pageData.price_package_qty  }}</span>
              </div>
              <div class="col-12 color-muted f12">Unidad</div>
            </div>
          </div>
          <div class="col-12 pt10 bt1 mt10" v-if="stock_edit">
            <div class="col-12 bg-color-primary lh36 t-c color-white f14 r5" @click="update_qty()">Guardar</div>
          </div>
        </div> 
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-3">Codigo</div>
          <div class="col-9 t-r color-black uppercase fw">{{ pageData.product_code }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-3">Nombre</div>
          <div class="col-9 t-r color-black uppercase fw">{{ pageData.product_name }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-3">Categoría</div>
          <div class="col-9 t-r color-black"> {{ pageData.cate_name }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-3">I.V.A</div>
          <div class="col-9 t-r color-black"> <span v-if="pageData.tax > 0">{{ pageData.tax * 100 }} %</span><span v-else>EXENTO</span></div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-3">Costo</div>
          <div class="col-9 t-r color-black">${{ fun.formatMoney(pageData.cost_ex1,2,'.',',') }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-3">Precio</div>
          <div class="col-9 t-r color-black">${{ fun.formatMoney(pageData.price_ex1,2,'.',',') }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10 mt5">
          <div class="col-6">Bulto <span class="fw" v-if="pageData.price_package_qty > 1">[ 1 x {{ fun.formatMoney(pageData.price_package_qty,0,'.',',') }} ]</span></div>
          <div class="col-6 t-r color-black">${{ fun.formatMoney(pageData.price_package_ex1,2,'.',',') }}</div>
        </div>  
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-6">Precio1 <span class="fw" v-if="pageData.price1_qty > 1">[ 1 x {{ fun.formatMoney(pageData.price1_qty,0,'.',',') }} ]</span></div>
          <div class="col-6 t-r color-black">${{ fun.formatMoney(pageData.price1_ex1,2,'.',',') }}</div>
        </div>       
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-6">Precio2 <span class="fw" v-if="pageData.price2_qty > 1">[ 1 x {{ fun.formatMoney(pageData.price2_qty,0,'.',',') }} ]</span></div>
          <div class="col-6 t-r color-black">${{ fun.formatMoney(pageData.price2_ex1,2,'.',',') }}</div>
        </div>  
        <div class="col-12 bg-color-white bb1 pl10 pr10 pt10 pb10">
          <div class="col-6">Precio3 <span class="fw" v-if="pageData.price3_qty > 1">[ 1 x {{ fun.formatMoney(pageData.price3_qty,0,'.',',') }} ]</span></div>
          <div class="col-6 t-r color-black">${{ fun.formatMoney(pageData.price3_ex1,2,'.',',') }}</div>
        </div> 
      </div>
    </div>
    <!--
    <div class="cover flex-c pl20 pr20" v-if="edit">
      <div class="col-12 bg-color-white pt5 pb5 pr10 pl10">
        <div class="col-12 f14 bb1 pb5 lh30">
          <div class="col-8">Ajuste de inventario</div>
          <div class="col-4 t-r" @click="stock_edit = false">
            <i class="iconfont icon-31guanbi color-muted"></i>
          </div>
        </div>
        <div class="col-12 pt10 pb10">
          <div class="col-5 t-c">
            <div class="col-12 mb5"><input type="number" class="b1 lh46 pl3 pr3 w12 r5 t-c f20" v-model="pageData.qty"> </div>
            <div class="col-12 color-muted f12">Bulto x 100u</div>
          </div>
          <div class="col-2 t-c f30"> + </div>
          <div class="col-5 t-c"> 
            <div class="col-12 mb5"><input type="number" class="b1 lh46 pl3 pr3 w12 r5 t-c f20" v-model="pageData.qty_min"> </div>
            <div class="col-12 color-muted f12">Unidad</div>
          </div>
        </div>
        <div class="col-12 bt1 pt10 pb5">
          <div class="col-12 bg-color-primary lh36 t-c color-white f14 r5" @click="update_qty()">Guardar</div>
        </div>
      </div>  
    </div>  
    -->
  </div>
</template>
<script>
export default {
  name: 'Product',
  data () {
    return {
      id: this.$route.query.id,
      appid: this.$route.query.appid,
      pageData: {},
      stock_edit: false,
      new_package: 0,
      new_qty: 0,
    }
  },
  created: function () {
    this.get_pageData();
  },
  methods: {
    get_pageData() {
      var post_data = {};
      post_data.id = this.id;
      post_data.appid = this.appid;
      post_data.stock_id = this.$route.query.stock_id;
      this.post(this.api_url + 'manage/product', post_data).then((res)=>{
        if(res.status == 1){
          this.pageData = res.data.product;
          console.log(this.pageData);
        }else{
          this.pageData = {}
        }
      })
    },
    //开关
    statusCh() {
      //如果是启用状态，提示是否禁用
      if(this.pageData.status == 1){
        //西班牙语提醒是否确认禁用
        this.$store.commit('setConfimBox',{type:'confim_exit',msg:'¿Está seguro de que desea desactivar este producto?',_this:this,focus:'',method:'statusChPost',arg1:'',arg2:''})
      }else{
        this.statusChPost();
      }
    },
    //开关提交
    statusChPost() {
      var post_data = {};
      post_data.id = this.id;
      post_data.appid = this.appid;
      post_data.status = this.pageData.status == 1 ? 0 : 1;
      this.post(this.api_url + 'manage/product_status_update', post_data).then((res)=>{
        if(res.status == 1){
          this.pageData.status = post_data.status;
        }
      })
    },
    //库存修改
    stock_edit_on() {
      this.stock_edit = true;
      this.new_package = Math.floor(this.pageData.qty / this.pageData.price_package_qty );
      this.new_qty = this.pageData.qty % this.pageData.price_package_qty;
    },
    //库存修改提交
    update_qty() {
      var post_data = {};
      post_data.id = this.id;
      post_data.appid = this.appid;
      post_data.stock_id = this.$route.query.stock_id;
      //需要转成数字格式再相加
      post_data.qty = parseInt(this.new_package) * this.pageData.price_package_qty + parseInt(this.new_qty);
      this.post(this.api_url + 'manage/product_qty_update', post_data).then((res)=>{
        if(res.status == 1){
          this.pageData.qty = post_data.qty;
          this.stock_edit = false;
        }
      })
    },
    //库存详情
    warehouseLog() {
      if(this.stock_edit){
        return;
      }
      this.$router.push({name:'M_WarehouseLog',query:{product_id: this.id}});
    },
  },
  directives: {
    selectOnFocus: {
      inserted(el) {
        el.addEventListener('focus', () => {
          el.select();
        });
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Main/Product.vue